<template>
  <Page
    :step="step"
    :desktop="desktop"
    :title="title"
    :message="message"
    :final="true"
  >
    <p>We’re busy building your order now. It will be shipped next working day. It should be with you in 3-4 working days.</p>
    <hr class="full-width-divider">
    <transition name="fade">
      <div v-if="showPassword">
        <h4>Please add a password</h4>

        <p>You’ll need a password to sign into your account.</p>

        <div class="input-wrap">
          <label for="text_field">Password</label>
          <input type="text">
        </div>

        <div class="input-wrap">
          <label for="text_field">Confirm password</label>
          <input type="text">
        </div>

        <!-- <p class="hint">
          (Or if you prefer, you can get a password later from the sign in page.)
        </p> -->

        <br>

        <button
          type="button"
          name="button"
          class="default cta"
          @click="hidePassword"
        >Submit</button>

        <hr class="full-width-divider">
      </div>
    </transition>

    <h4>Where to next?</h4>

    <p>
      Share toucanBox with friends: get <strong>50% off</strong> your next box for each friend who signs up with your unique code and a <strong>free</strong> box for them.<br>
      <a>Share with friends</a>
    </p>

    <p>
      Or head over to your personal account page and find out how to manage and modify your subscription or access extras.<br>
      <a>Go to your account</a>
    </p>

    <!-- <hr class="full-width-divider">

    <h4>Before you go...</h4>

    <p>Help us to tailor our service to you. What is your relationship to the child?<br><a @click="toggleRelationship">Add relationship</a></p>

    <transition name="fade">
      <div
        v-if="relationshipInput"
        class="inline-success-input"
      >
        <div class="input-wrap">
          <label>
            What is your relationship to the children?
          </label>
          <select>
            <option
              selected="selected"
              disabled="disabled"
              hidden="hidden"
              value=""
            />
            <option value="1">Parent</option>
            <option value="2">Grandparent</option>
            <option value="3">Aunt/Uncle</option>
            <option value="4">Family friend</option>
            <option value="5">Sibling</option>
          </select>
        </div>

        <button
          type="button"
          name="button"
          class="default cta"
        >Submit</button>
      </div>
    </transition>

    <p>Can we have your number? This isn't obligatory but it may help if we need to get in touch with you about your order.<br><a @click="togglePhoneNumber">Add a phone number</a></p>

    <transition name="fade">
      <div v-if="phoneNumberInput">
        <div class="input-wrap">
          <label for="text_field">Your phone number</label>
          <input type="text">
        </div>

        <button
          type="button"
          name="button"
          class="default cta"
        >Submit</button>
      </div>
    </transition> -->

  </Page>
</template>

<script>
import Page from '../library/page.vue'

export default {
  name: 'Payment',
  props: {
    step: {
      type: Number,
      default: 0
    },
    desktop: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Page
  },
  data () {
    return {
      title: 'WELCOME ABOARD!',
      message: 'You’ll receive a confirmation email with the details of your subscription.',
      relationshipInput: false,
      phoneNumberInput: false,
      showPassword: true
    }
  },
  activated: function () {
    this.$events.$emit('dismiss-order', 'success')
  },
  methods: {
    next: function (event) {
      this.$emit('next')
    },
    toggleRelationship: function (event) {
      this.relationshipInput = !this.relationshipInput
    },
    togglePhoneNumber: function (event) {
      this.phoneNumberInput = !this.phoneNumberInput
    },
    hidePassword: function (event) {
      this.showPassword = !this.showPassword
    }
  }
}
</script>

<style lang="scss" scoped>
  // More than usual margin wanted for full-width-divider
  .full-width-divider {
    margin: 1.5em -30px 2em -30px;
  }
  .inline-success-input {
    padding-bottom: 1em;
  }
  // Long text names on buttons - push the icon over on small screens
  @media only screen and (max-width: 330px) {
    .pushed {
      padding-right: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/success.vue